import script from "./StartedProjectsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartedProjectsPage.vue?vue&type=script&setup=true&lang=ts"

import "./StartedProjectsPage.vue?vue&type=style&index=0&id=01a0948d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a0948d"]])

export default __exports__